import { Tile as TileLayer } from 'ol/layer'
import { WMTS } from 'ol/source'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import { getProjectionConfig } from '../projections'
import { getStandardLayerProps } from './utils'

export function createWmtsLayer(config) {
  const {
    url,
    projection: projectionCode,
    format = 'image/png',
    style = 'default',
    wrapX = false,
    source = {},
  } = config

  const projectionConfig = getProjectionConfig(projectionCode)

  return new TileLayer({
    ...getStandardLayerProps(config),
    source: new WMTS({
      url,
      layer: source.layer,
      matrixSet: projectionCode,
      format,
      projection: projectionConfig.projection,
      tileGrid: new WMTSTileGrid({
        origin: projectionConfig.wmts.origin,
        resolutions: projectionConfig.wmts.resolutions,
        matrixIds: projectionConfig.wmts.matrixIds,
      }),
      style,
      wrapX,
      ...source,
    }),
  })
}
